import React, {useEffect, useState} from "react";
import {Box, Tab, Tabs} from "@mui/material";
import TeamsSettingsTogglesContainer from "./TeamsSettingsTogglesContainer";
import TrendsOrganizationSettingsContainer from "./TrendsOrganizationSettingsContainer";
import useGetTrendsOrganization from "../../hooks/useGetTrendsOrganization";

const TAB_TEAMS = 'teams';
const TAB_TRENDS = 'trends';

const tabStyles = {
    minHeight: 42,
    '& .MuiTab-root': {
        fontFamily: 'LarsseitMedium',
        fontSize: '14px',
        textTransform: 'none',
        color: '#495D5E',
    },
    '& .Mui-selected': {
        color: '#3081ED',
    },
    '& .MuiTabs-indicator': {
        backgroundColor: '#3081ED',
    },
};

export default function CompanyInfoSettingsTabs({
    mode,
    organization,
    organizationTrendsId,
    label,
}) {
    const [selectedTab, setSelectedTab] = useState(TAB_TEAMS);

    useEffect(() => {
        setSelectedTab(TAB_TEAMS);
    }, [organization?.id]);

    const trendsFetchEnabled = selectedTab === TAB_TRENDS;
    const {
        trendsOrganization,
        loading: loadingTrendsOrganization,
        updatingField: updatingTrendsOrganizationField,
    } = useGetTrendsOrganization(organizationTrendsId, trendsFetchEnabled);

    const handleTabChange = (_event, value) => {
        setSelectedTab(value);
    };

    return (
        <Box>
            <Tabs
                value={selectedTab}
                onChange={handleTabChange}
                aria-label="Company settings tabs"
                sx={tabStyles}
            >
                <Tab value={TAB_TEAMS} label={label.TEAMS_SETTINGS} />
                <Tab value={TAB_TRENDS} label={label.TRENDS_SETTINGS} />
            </Tabs>
            {selectedTab === TAB_TEAMS && (
                <Box role="tabpanel" sx={style.tabPanel}>
                    <TeamsSettingsTogglesContainer
                        mode={mode}
                        organization={organization}
                        label={label}
                    />
                </Box>
            )}
            {selectedTab === TAB_TRENDS && (
                <Box role="tabpanel" sx={style.tabPanel}>
                    <TrendsOrganizationSettingsContainer
                        mode={mode}
                        organizationTrendsId={organizationTrendsId}
                        label={label}
                        trendsOrganization={trendsOrganization}
                        loading={loadingTrendsOrganization}
                        updatingField={updatingTrendsOrganizationField}
                    />
                </Box>
            )}
        </Box>
    );
}

const style = {
    tabPanel: {
        pt: '16px',
    },
};
